// extracted by mini-css-extract-plugin
export default {"formWarning":"index_formWarning_-3C5D"};